<template>
  <div>
    <v-row>
      <v-col cols="4">
        <v-text-field
          label="Nombre"
          outlined
          v-model="filters.nombre"
          color="#00a7e4"
          type="text"
          item-text="nombre"
          return-object
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Apellido paterno"
          outlined
          v-model="filters.apellido_paterno"
          color="#00a7e4"
          type="text"
          item-text="apellido_paterno"
          return-object
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Apellido materno"
          outlined
          v-model="filters.apellido_materno"
          color="#00a7e4"
          type="text"
          item-text="apellido_materno"
          return-object
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Correo"
          outlined
          v-model="filters.correo"
          color="#00a7e4"
          type="email"
          item-text="correo"
          return-object
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Telefono"
          outlined
          v-model="filters.telefono"
          color="#00a7e4"
          type="tel"
          maxlength="10"
          counter="10"
          item-text="telefono"
          return-object
          clearable
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="text-align: end;">
        <v-btn
          rounded
          dark
          outlined
          color="#00a7e4"
          @click="$emit('beforeStep')"
          style="margin-right: 11px;"
        >
          <span>
            Anterior
          </span>
        </v-btn>
        <v-btn
          rounded
          dark
          class="common-botton"
          @click="getClienteByFiltersAreaNegocio"
          :disabled="!completeFilters"
          :loading="loading"
        >
          <span>
            Buscar
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <showClients
      :dialog="dialogClients"
      :clientes="clientes"
      :total="total"
      :searchForRFC="searchForRFC"
      @closeModal="dialogClients = false"
      @getClientesPagination="getClienteByFiltersAreaNegocio"
      @postClienteSelecciondo="postClienteSelecciondo"
    />
  </div>
</template>

<script>
import { getClienteByFiltersAreaNegocio } from "@/services/cliente/Clientes";
import showClients from "@/components/commonComponents/modals/showClients.vue";
export default {
  components: {
    showClients,
  },
  props: {
    currentStep: Number,
    searchForRFC: {
      type: Boolean,
      default: false,
    },
    finalFilters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      filters: {
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        telefono: null,
        correo: null,
      },
      loading: false,
      dialogClients: false,
      clientes: [],
      total: null,
    };
  },
  methods: {
    async getClienteByFiltersAreaNegocio(e = null) {
      try {
        this.loading = true;
        const finalFilters = {};
        Object.keys(this.filters).map((e) => {
          if (!this.filters[e]) delete this.filters[e];
          else finalFilters[e] = String(this.filters[e]).trim();
        });
        const size = e?.size ?? 10;
        const page = e?.page ? Number((e.page - 1) * e.size) : 0;

        let response = await getClienteByFiltersAreaNegocio(
          finalFilters,
          size,
          page
        );
        if (response.data.length > 0) {
          this.clientes = response.data;
          this.total = response.total;
          this.dialogClients = true;
        } else {
          this.$toast.info("No se encontraron coincidencias con los filtros");
        }
        this.loading = false;
      } catch (e) {
        this.$toast.error("A ocurrido un error en encontrar cliente", e);
        this.loading = false;
      }
    },
    postClienteSelecciondo(e) {
      this.$emit("postClienteSelecciondo", e);
      this.dialogClients = false;
    },
  },
  computed: {
    completeFilters() {
      return Object.entries(this.filters).some(([key, val]) => {
        if (!val) return false;
        const str = String(val).trim();
        if (key === "telefono") {
          return /^\d{10}$/.test(str);
        }
        if (key === "correo") {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
        }
        return str.length >= 3;
      });
    },
  },
  watch: {
    searchForRFC(val) {
      if (val) {
        Object.assign(this.filters, this.finalFilters);
        this.getClienteByFiltersAreaNegocio();
      }
    },
    dialogClients(val) {
      if (!val) this.$emit("restarRFCflag");
    },
  },
};
</script>
